// Boilerplate required by Redux.
// Use this reducer for a piece of
// state that doesn't change.
// For example, window.settings
// gets passed into apps, but then
// never changes, regardless of
// what's going on. You would use
// this generic reducer to maintain
// those settings on app state.
export default (state = {}) => state;
